const API_BASE_URL = process.env.NEXT_PUBLIC_API_URL || "https://sttbackend.99aitech.com";

export { API_BASE_URL };
